import { AllReasonsResponse, ReasonsDropDownResponse, ReasonsResponse } from '@gtpl/shared-models/masters';
import { ApiTags } from '@nestjs/swagger';
import {ReasonsService} from './reasons.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ReasonsDTO } from './dto/reasons.dto';
import { ReasonsRequest } from './dto/reasons.request';

@ApiTags('Reasons')
@Controller('reasons')
export class ReasonsController {
    constructor(
        private reasonsService: ReasonsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}
 /**
     * creates  a Reason
     * @param ReasonsDto Reason DTO
     * @returns  reasonResponse
     */
  @Post('/createReasons')
  async createReasons(@Body() reasonsDTO:ReasonsDTO, @Req() request:Request): Promise<ReasonsResponse> {
      try {
       return await this.reasonsService.createReasons(reasonsDTO,false,request);
     } catch (error) {
          return this.applicationExceptionHandler.returnException(ReasonsResponse, error);
     }
   }

    /**
     * gets all the Value reasons
     * @returns AllReasonsResponse which returns all the Value reasons  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

     @Post('/getAllReasons')
    async getAllReasons(): Promise<AllReasonsResponse> {
        try {
            return await this.reasonsService.getAllReasons();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllReasonsResponse, error);
        }
    }

      /**
     * Activate Or De-Activate Value reason
     * @param getSingleReasons reason 
     * @returns Value Response
     */
       @Post('/activateOrDeactivateReasons')
       async activateOrDeactivateReasons(@Body() reasonsReq: ReasonsRequest): Promise<ReasonsResponse> {
           try {
               return await this.reasonsService.activateOrDeactivateReasons(reasonsReq);
           } catch (err) {
               return this.applicationExceptionHandler.returnException(ReasonsResponse, err);
           }
       }
       /**
     *  updates a  value reason
     * @param ReasonsDto Reasons DTO
     * @returns ReasonsResponse
     */
    @Post('/updateReasons')
    async updateReasons(@Body() reasonsDTO:ReasonsDTO, @Req() request:Request): Promise<ReasonsResponse> {
        try {
         return await this.reasonsService.createReasons(reasonsDTO,true,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(ReasonsResponse, error);
       }
     }

     
  @Post('/getReasonsDropDownInfo')
  async getReasonsDropDownInfo(): Promise<ReasonsDropDownResponse> {
    try {
      return await this.reasonsService.getReasonsDropDownInfo();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ReasonsDropDownResponse, error);
    }
  }

  @Post('/getReasonsAgainstCategory')
  async getReasonsAgainstCategory(@Body() req:any): Promise<AllReasonsResponse> {
    try {
      return await this.reasonsService.getReasonsAgainstCategory(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllReasonsResponse, error);
    }
  }

  @Post('/getAllReasonsgrn')
  async getAllReasonsgrn(): Promise<AllReasonsResponse> {
    console.log("................iam controller...........");
    
        try {
      return await this.reasonsService.getAllReasonsgrn();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllReasonsResponse, error);
    }
  }
}
